import {
  ChosenAttributesInput,
  ProductTaxonomyEnum,
} from "../../types/generalTypes";
import { useParams } from "react-router-dom";
import { useSearchParams } from "./useSearchParams";
import { useShopHandlers } from "./useShopHandlers";
import { usePersistedQuery } from "./usePersistedQuery";
import {
  persistKeyFromVariables,
  QUERY_TTL,
} from "../helpers/persistedQueryCache";

import * as shopQueries from "../../queries/shop";

export const useAttributeFiltersQuery = (args?: ChosenAttributesInput) => {
  const params = useParams<any>();
  const searchParams = useSearchParams();
  const shopHandlers = useShopHandlers();

  const categoryTerms = {
    taxonomy: ProductTaxonomyEnum.PRODUCTCATEGORY,
    terms:
      params.childChildChildCategory ||
      params.childChildCategory ||
      params.childCategory ||
      params.parentCategory ||
      "",
  };

  const initialCategoryTerms = args ? [categoryTerms, args] : [categoryTerms];

  const filteredCategoryTerms = initialCategoryTerms.filter(
    (term) => term.terms !== ""
  );

  const taxonomyFilters = shopHandlers.prepareTaxonomyFilters(searchParams);
  const chosenAttributes = [
    ...filteredCategoryTerms,
    ...taxonomyFilters,
  ] as ChosenAttributesInput[];

  const persistKey = persistKeyFromVariables(
    "attributeFilters",
    chosenAttributes
  );

  const { loading, error, data, refetch } = usePersistedQuery<
    shopQueries.GetAttributeFiltersResponse,
    shopQueries.GetAttributeFiltersVariables
  >(shopQueries.getAttributeFilters, {
    variables: {
      chosenAttributes,
    },
    persistKey,
    persistTtl: QUERY_TTL.attributeFilters,
  });

  return {
    loading,
    error,
    data,
    refetch,
  };
};
